import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { AttendanceDetailEditModeSearchSchema } from '../../-shared/attendance-detail-edit-mode-search-schema';
import { AttendanceStructureDetailLayoutContent } from './-components/AttendanceStructureDetailLayoutContent';
export const Route = createFileRoute('/_staff/attendance-engine/_layout/attendance-structures/$structureId/_layout')({
  // 編集状態を持つ Provider は `_layout` 側にあるため、初期モードの検索パラメータも
  // ここで受ける（子タブから読めるように）。
  validateSearch: zodValidator(AttendanceDetailEditModeSearchSchema),
  component: AttendanceStructureDetailLayoutContent
});